import { render, staticRenderFns } from "./UserAccessDetails.vue?vue&type=template&id=68f9b4f7&lang=pug"
import script from "./UserAccessDetails.vue?vue&type=script&lang=js"
export * from "./UserAccessDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jquispe/itcm-inca-platform-app/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('68f9b4f7')) {
      api.createRecord('68f9b4f7', component.options)
    } else {
      api.reload('68f9b4f7', component.options)
    }
    module.hot.accept("./UserAccessDetails.vue?vue&type=template&id=68f9b4f7&lang=pug", function () {
      api.rerender('68f9b4f7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/tasks/datastudio/components/UserAccessDetails.vue"
export default component.exports